export enum ShipmentLoaderKey {
  LIST_SHIPMENTS = 'shipment-list',
  GET_SHIPMENT = 'shipment-get',
  GET_KPIS = 'shipment-kpis',
  CREATE_SHIPMENT = 'shipment-create',
  GET_EXCEPTIONS = 'shipment-exceptions',
}
